// Standardized color palette for the yield simulator UI.
// Loosely follows Royco brand guidelines (Bone White, Carbon Ink, Burnished Gold, etc.)
// with semantic extensions for positive/negative/caution states.

const COLORS = {
  // ── Brand Foundation ──
  bg:             '#FAF6F1',   // Bone White — page background
  surface:        '#FFFFFF',   // Cards, panels
  surfaceAlt:     '#F5F0EA',   // Code blocks, inputs, metric tiles
  ink:            '#111111',   // Carbon Ink — headings, primary text
  accent:         '#C8873E',   // Burnished Gold — buttons, toggles, active states
  accentAlt:      '#8B7D5E',   // Antique Bronze — vanilla benchmark
  champagne:      '#C4B5A0',   // Champagne Ash — subtle accent

  // ── Neutral Scale (warm-toned) ──
  textBody:       '#4A4540',   // Readable body text
  textSecondary:  '#7A7570',   // Labels, section headers
  textTertiary:   '#A09A92',   // Hints, captions, muted text
  borderLight:    '#EDE7DF',   // Subtle dividers, table row lines
  border:         '#E5DDD3',   // Card borders, main dividers
  borderDark:     '#D5CCC0',   // Input borders, inactive toggles

  // ── Semantic: Positive ──
  positive:       '#2D7A4F',   // Forest green — positive text, checkmarks
  positiveBg:     '#EBF5EE',   // Light green wash
  positiveBorder: '#B8D9C2',   // Green border

  // ── Semantic: Negative ──
  negative:       '#C44B3F',   // Warm red — danger text, fail badges
  negativeBg:     '#FDEEEB',   // Light red wash
  negativeBorder: '#E8C0B8',   // Red border

  // ── Semantic: Caution ──
  caution:        '#B8860B',   // Dark gold — warning text
  cautionBg:      '#FDF6E8',   // Light amber wash
  cautionBorder:  '#E5D5A8',   // Amber border

  // ── Token / Protocol ──
  ethBlue:        '#627EEA',   // Ethereum brand blue
  lidoBlue:       '#00A3FF',   // Lido / wstETH brand blue
};

export default COLORS;
